import {
  HeatOverrideMode,
  Permission,
  Tenant,
} from "src/store/api/generatedApi";

export const OVERRIDE_RECIPES_PERMISSIONS: Permission[] = [
  "manage_overrides_catalog",
];

export const OVERRIDE_HISTORY_PERMISSIONS: Permission[] = [
  "view_override_history",
];

export const ADD_MISSING_OVERRIDES_PERMISSIONS: Permission[] = [
  "edit_override_history",
];

export const overrideHistoryEditingEnabled = ({
  heat_override_mode: heatOverrideMode,
  heat_override_options: heatOverrideOptions,
}: Partial<Tenant>): boolean =>
  heatOverrideMode === OVERRIDES_TENANT_SETTINGS.heat_override_mode &&
  (heatOverrideOptions ?? []).includes("edit_history");

export const getOverridesPermissions = (
  tenant: Partial<Tenant>
): Permission[] => [
  ...OVERRIDE_HISTORY_PERMISSIONS,
  ...(tenant.heat_override_mode === OVERRIDES_TENANT_SETTINGS.heat_override_mode
    ? OVERRIDE_RECIPES_PERMISSIONS
    : []),
  ...(overrideHistoryEditingEnabled(tenant)
    ? ADD_MISSING_OVERRIDES_PERMISSIONS
    : []),
];

export const OVERRIDES_TENANT_SETTINGS = {
  heat_override_mode: "catalog",
} satisfies Partial<Tenant>;

export const DELTA_OVERRIDES_TENANT_SETTINGS = {
  heat_override_mode: "delta",
} satisfies Partial<Tenant>;

export const heatOverridesEnabled = (
  heatOverrideMode: HeatOverrideMode | undefined
): boolean => heatOverrideMode !== undefined && heatOverrideMode !== "disabled";

export const EDIT_HEAT_RECIPE_PERMISSIONS: Permission[] = ["crane_supervisor"];

export const HEAT_QUEUE_PERMISSIONS: Permission[] = [
  "crane_supervisor",
  "crane_supervisor_viewer",
];
